module.exports = __webpack_public_path__ + "static/media/kia_3.ff146976.jpg";